import { render, staticRenderFns } from "./CheckboxWidget.vue?vue&type=template&id=a9d86456&lang=pug&"
import script from "./CheckboxWidget.vue?vue&type=script&lang=js&"
export * from "./CheckboxWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports